var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17C18 15.4903 16.6083 14.2067 14.6667 13.7301M13 17C13 15.0847 10.7617 13.5333 8 13.5333C5.23833 13.5333 3 15.0847 3 17M13 10.9333C13.8841 10.9333 14.7319 10.5681 15.357 9.91797C15.9821 9.26784 16.3333 8.38608 16.3333 7.46667C16.3333 6.54725 15.9821 5.66549 15.357 5.01536C14.7319 4.36524 13.8841 4 13 4M8 10.9333C7.11594 10.9333 6.2681 10.5681 5.64298 9.91797C5.01786 9.26784 4.66667 8.38608 4.66667 7.46667C4.66667 6.54725 5.01786 5.66549 5.64298 5.01536C6.2681 4.36524 7.11594 4 8 4C8.88405 4 9.7319 4.36524 10.357 5.01536C10.9821 5.66549 11.3333 6.54725 11.3333 7.46667C11.3333 8.38608 10.9821 9.26784 10.357 9.91797C9.7319 10.5681 8.88405 10.9333 8 10.9333Z",
    stroke: "#79808A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.3418e663e70bbcb9f3052ca8fa60c1f8.svg";
export { ForwardRef as ReactComponent };